import { connect } from 'react-redux';
import { RootState } from '@redux/reducer';
import ReasonForCover, { ValueProps } from './ReasonForCoverField';

const mapStateToProps = (state: RootState): ValueProps => ({
  isQuoteForMyself: state.account.customer.isQuoteForMyself,
});

export default connect(mapStateToProps)(ReasonForCover);
